import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';

import SalesforceSvgColor from '../assets/salesforce.svg';

export const SalesforceColor = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="color-lang-salesforce" className={cx('sdkIcon', className)} size={size} {...props}>
    <SalesforceSvgColor />
  </LegacyIcon>
);
